import { lazy } from "react"
import { RouteConfig } from "react-router-config"

import { NotFound } from "@/components"
import Dashboard from "@/pages/Dashboard/Dashboard"
import {
  AddFunds,
  AddReason,
  Address,
  Automation,
  AutomationFailTable,
  Integration,
  IntegrationDHL,
  IntegrationDhlExpress,
  IntegrationFedex,
  IntegrationGls,
  IntegrationPacketa,
  IntegrationSendCloud,
  IntegrationSendle,
  IntegrationShipping,
  IntegrationShiprocket,
  IntegrationShipStation,
  LabelHistory,
  MethodForm,
  PreferredLanguage,
  Reason,
  ReasonGroup,
  RechargeRecords,
  RulesForm,
  RulesFormBlockList,
  SolutionForm,
} from "@/pages/Setting/components"

const Demo = lazy(() => import("@/pages/DemoPage/index"))
const Setting = lazy(() => import("@/pages/Setting/Setting"))
const Management = lazy(() => import("@/pages/Management/Management"))
const Notification = lazy(() => import("@/pages/Notification/Notification"))
const ReturnPage = lazy(() => import("@/pages/ReturnPage/ReturnPage"))
const ReturnPageLayout = lazy(
  () => import("@/pages/ReturnPageLayout/ReturnPageLayout"),
)
const OrderDetail = lazy(() => import("@/pages/Management/OrderDetail"))
const Feedback = lazy(() => import("@/pages/Feedback/Feedback"))
const AppIntegration = lazy(
  () => import("@/pages/AppIntegration/AppIntegration"),
)
const EmailEdit = lazy(() => import("@/pages/EmailEdit"))
const LanguageEdit = lazy(() => import("@/pages/LanguageEdit"))
const Analytics = lazy(() => import("@/pages/Analytics"))
const AnalyticsReturnReasonsList = lazy(
  () => import("@/pages/Analytics/components/ReturnReasonsList"),
)
const AnalyticsProductsByReason = lazy(
  () => import("@/pages/Analytics/components/ProductsByReasonList"),
)
const AnalyticsProductsList = lazy(
  () => import("@/pages/Analytics/components/ProductsList"),
)

const AnalyticsReasonsByProduct = lazy(
  () => import("@/pages/Analytics/components/ReasonsByProduct"),
)

// const Invoices = lazy(() => import("@/pages/Billing/Invoices"))
const Billing = lazy(() => import("@/pages/Plan"))
const FreeReturnservice = lazy(() => import("@/pages/FreeReturnservice/index"))
const FreeReturnserviceLayout = lazy(
  () => import("@/pages/FreeReturnserviceEdit"),
)

// const Affiliate = lazy(() => import("@/pages/Affiliate"))

const AutoRefund = lazy(() => import("@/pages/AutomationLayout/AutoRefund"))
const AutoApprove = lazy(() => import("@/pages/AutomationLayout/AutoApprove"))
const AutoExchange = lazy(() => import("@/pages/AutomationLayout/AutoExchange"))
const SpecificRules = lazy(
  () => import("@/pages/AutomationLayout/SpecificRules"),
)

// 因为时间有限，如果需要在侧边菜单栏显示，还需要再改一下 Menu.tsx
const routes: RouteConfig[] = [
  {
    component: Dashboard,
    path: "/",
    key: "Dashboard",
    exact: true,
  },
  {
    component: Demo,
    path: "/demo-page",
    key: "Demo",
    exact: true,
  },
  {
    component: Management,
    path: "/return-management",
    key: "Management",
    exact: true,
  },
  {
    component: OrderDetail,
    path: "/return-management/test-order-management/:scenario",
    key: "ManagementTestOrderDetail",
    exact: true,
  },
  {
    component: OrderDetail,
    path: "/return-management/order-management/:id",
    key: "Management",
    exact: true,
  },
  {
    component: ReturnPage,
    path: "/return-page",
    key: "ReturnPortal",
    exact: true,
  },
  {
    component: ReturnPageLayout,
    path: "/return-page/configuration",
    key: "ReturnPageLayoutConfiguration",
    exact: true,
  },
  {
    component: AutoRefund,
    path: "/automation-configuration/auto-refund/:id?",
    key: "AutomationLayoutConfigurationAutoRefund",
    exact: true,
  },
  {
    component: AutoApprove,
    path: "/automation-configuration/auto-approve/:id?",
    key: "AutomationLayoutConfigurationAutoApprove",
    exact: true,
  },
  {
    component: AutoExchange,
    path: "/automation-configuration/auto-exchange/:id?",
    key: "AutomationLayoutConfigurationAutoExchange",
    exact: true,
  },
  {
    component: SpecificRules,
    path: "/automation-configuration/specific-rules/:id?",
    key: "AutomationLayoutConfigurationSpecificRules",
    exact: true,
  },
  {
    path: "/settings/add-funds",
    key: "AddFunds",
    exact: true,
    component: AddFunds,
  },
  {
    path: "/settings/label-history",
    key: "LabelHistory",
    exact: true,
    component: LabelHistory,
  },
  {
    path: "/settings/recharge-records",
    key: "RechargeRecords",
    exact: true,
    component: RechargeRecords,
  },
  {
    path: "/settings",
    key: "Setting",
    component: Setting,
    routes: [
      {
        path: "/settings",
        key: "Reason",
        exact: true,
        component: Reason,
      },
      {
        path: "/settings/address",
        key: "Address",
        exact: true,
        component: Address,
      },
      {
        path: "/settings/logistics-integration",
        key: "Integration",
        exact: true,
        component: Integration,
      },
      {
        path: "/settings/logistics-integration/direct-integration",
        key: "Integration",
        exact: true,
        component: Integration,
      },
      {
        path: "/settings/logistics-integration/indirect-integration",
        key: "Integration",
        exact: true,
        component: Integration,
      },
      {
        path: "/settings/logistics-integration/shippo/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationShipping,
      },
      {
        path: "/settings/logistics-integration/sendcloud/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationSendCloud,
      },
      {
        path: "/settings/logistics-integration/Fedex/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationFedex,
      },
      {
        path: "/settings/logistics-integration/ship-station/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationShipStation,
      },
      {
        path: "/settings/logistics-integration/DHL/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationDHL,
      },
      {
        path: "/settings/logistics-integration/Dhl-express/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationDhlExpress,
      },
      {
        path: "/settings/logistics-integration/shiprocket/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationShiprocket,
      },
      {
        path: "/settings/logistics-integration/sendle/:in_id/:config_id",
        key: "Integration",
        exact: true,
        component: IntegrationSendle,
      },
      {
        path: "/settings/logistics-integration/gls/:in_id/:config_id",
        key: "gls",
        exact: true,
        component: IntegrationGls,
      },
      {
        path: "/settings/logistics-integration/packeta/:in_id/:config_id",
        key: "packeta",
        exact: true,
        component: IntegrationPacketa,
      },
      {
        path: "/settings/eligibility-rules",
        key: "Rules",
        exact: true,
        component: RulesForm,
      },
      {
        path: "/settings/solutions",
        key: "Solutions",
        exact: true,
        component: SolutionForm,
      },
      {
        path: "/settings/shipping-method",
        key: "Method",
        exact: true,
        component: MethodForm,
      },
      {
        path: "/settings/reason",
        key: "Reason",
        exact: true,
        component: Reason,
      },
      {
        path: "/settings/add-reason/:code?/:id?",
        key: "Reason",
        exact: true,
        component: AddReason,
      },
      {
        path: "/settings/add-group/:id?",
        key: "Reason",
        exact: true,
        component: ReasonGroup,
      },
      {
        path: "/settings/eligibility-rules-block",
        key: "RulesFormBlockList",
        exact: true,
        component: RulesFormBlockList,
      },
      {
        path: "/settings/automation",
        key: "Automation",
        exact: true,
        component: Automation,
      },
      {
        path: "/settings/automation/fail-list/:id?",
        key: "Automation",
        exact: true,
        component: AutomationFailTable,
      },
      {
        component: Notification,
        path: "/settings/notification",
        key: "Notification",
        exact: true,
      },
      {
        path: "/settings/language",
        key: "Language",
        exact: true,
        component: PreferredLanguage,
      },
    ],
  },
  {
    component: FreeReturnservice,
    path: "/free-return-service",
    key: "FreeReturnservice",
    exact: true,
  },
  {
    component: FreeReturnserviceLayout,
    path: "/free-return-service/configuration/:type/:id?",
    key: "FreeReturnserviceLayoutConfiguration",
    exact: true,
  },
  {
    component: Billing,
    path: "/billing",
    key: "Billing",
    exact: true,
  },
  {
    component: AppIntegration,
    path: "/integration",
    key: "AppIntegration",
    exact: true,
  },
  {
    component: Feedback,
    path: "/feedback",
    key: "Feedback",
    exact: true,
  },
  {
    component: EmailEdit,
    path: "/email-edit/:eventStatus",
    key: "EmailEdit",
    exact: true,
  },
  {
    component: LanguageEdit,
    path: "/language-edit/:lang",
    key: "LanguageEdit",
    exact: true,
  },
  {
    path: "/analytics",
    component: Analytics,
    key: "Analytics",
    exact: true,
  },
  {
    path: "/analytics/return-reasons-list",
    key: "ReturnReasonsList",
    exact: true,
    component: AnalyticsReturnReasonsList,
  },
  {
    path: "/analytics/products-by-reason/:reason_id/:reason_name?",
    key: "ProductsByReason",
    exact: true,
    component: AnalyticsProductsByReason,
  },
  {
    path: "/analytics/products-list",
    key: "ProductsList",
    exact: true,
    component: AnalyticsProductsList,
  },
  {
    path: "/analytics/reasons-by-product/:variant_id/:product_name?",
    key: "ReasonsByProduct",
    exact: true,
    component: AnalyticsReasonsByProduct,
  },
  {
    path: "*",
    component: NotFound,
  },
]

export default routes
